import { configureStore } from "@reduxjs/toolkit";
import AllProductSlice from "../redux/slices/AllProductSlice";
import AddTocartSlice from "./slices/AddTocartSlice";
import viewCart from "../redux/slices/ViewCartSlice";
import GetCategoryReducer from "./slices/GetCategorySlice";
import ConfirmOrderReducer from "../redux/slices/ConfirmOrderSlice";
import GetBrandsSlice from "../redux/slices/GetBrandSlice";
import RecentViewReducer from "../redux/slices/RecentViewSlice";
import GetRecentViewReducer from "../redux/slices/GetRecentViewSlice";
import AddWishlistReducer from "../redux/slices/AddWishlistSlice";
import GetWishListReducer from "../redux/slices/GetWishList";
import GetSubCategoryReducer from "../redux/slices/GetSubCategorySlice";
import GetCategoryDataReducer from "../redux/slices/GetCategoryDataSlice";
import GetCategorySubCateReducer from "../redux/slices/GetCategorySubCateSlice";
import RelatedProductReducer from "../redux/slices/RelatedProductSlice";
import GetOfferReducer from "../redux/slices/GetOfferSlice";
import GetOfferNameReducer from "../redux/slices/GetOfferNameSlice";
import FilterProductReducer from "../redux/slices/FilterProductSlice";
import SignUpApiReducer from "../redux/slices/SignUpSlice";
import LoginApiReducer from "../redux/slices/LoginSlice";
import PriceFilterReducer from "../redux/slices/PriceFilterSlice";
import GetProfileReducer from "../redux/slices/GetProfileSlice";
import SearchProductReducer from "../redux/slices/SearchProductSlice";
import GetReviewReducer from "../redux/slices/GetReviewSlice";
import ProductDetailsReducer from "../redux/slices/ProductByIdSlice";
import GetBannerReducer from "../redux/slices/GetBannerSlice";
import GetCouponDataReducer from "../redux/slices/GetCouponSlice";
import ApplyCouponReducer from "../redux/slices/ApplyCoupon";
import CheckoutReducer from "../redux/slices/CheckoutSlice";
import SellerLoginApiReducer from "../redux/slices/SellerLoginSlice";
import SellerRegisterReducer from "./slices/SellerRegisterSlice";
import SellerAccountReducer from "./slices/SellerAccountSlice";
import SellerGstReducer from "./slices/SellerGstSlice";
import SellerPanReducer from "./slices/SellerPanSlice";
import SellerAddressReducer from "./slices/SellerAddressSlice";
import SellerBankReducer from "./slices/SellerBankSlice";
import GetSellerDataReducer from "../redux/slices/GetSellerDataSlice";
import errorReducer from "../redux/slices/errorSlice";

const store = configureStore({
  reducer: {
    product: AllProductSlice,
    cart: AddTocartSlice,
    viewCart: viewCart,
    category: GetCategoryReducer,
    confirmOrder: ConfirmOrderReducer,
    brands: GetBrandsSlice,
    recentView: RecentViewReducer,
    viewData: GetRecentViewReducer,
    wishList: AddWishlistReducer,
    getWishlistData: GetWishListReducer,
    subCategory: GetSubCategoryReducer,
    categoryData: GetCategoryDataReducer,
    getCategorySub: GetCategorySubCateReducer,
    relatedProduct: RelatedProductReducer,
    offerData: GetOfferReducer,
    offerName: GetOfferNameReducer,
    filterProduct: FilterProductReducer,
    signData: SignUpApiReducer,
    loginData: LoginApiReducer,
    priceRange: PriceFilterReducer,
    getProfileData: GetProfileReducer,
    searchData: SearchProductReducer,
    getReviewData: GetReviewReducer,
    productById: ProductDetailsReducer,
    getBannerData: GetBannerReducer,
    getCoupon: GetCouponDataReducer,
    applyCoupon: ApplyCouponReducer,
    checkout: CheckoutReducer,
    sellerloginData: SellerLoginApiReducer,
    sellerRegister: SellerRegisterReducer,
    sellerAccount: SellerAccountReducer,
    sellerGst: SellerGstReducer,
    sellerPan: SellerPanReducer,
    selleraddress: SellerAddressReducer,
    sellerBank: SellerBankReducer,
    getSeller: GetSellerDataReducer,
    error: errorReducer
  },
});

export default store;
